document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-list').forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > .collection-item'));
    if (items.length < 2) return;

    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }

    items.forEach(function (item) {
      list.appendChild(item);
    });
  });
});
